import React from "react"
import styled from "styled-components"
import { StyledHeading, StandardContainer } from "../common"
import { BlogCard } from "../../components/blog"

const StyledDiv = styled.div`
  padding: 100px 0;
  background: #f3f3f3;
`

// Styles
const BlogGrid = styled(StandardContainer)`
  display: grid;
  grid-gap: 4rem;
  margin-top: 5rem;
  margin-bottom: 5rem;
  padding: 0 !important;

  /* Medium */
  @media ${(props) => props.theme.breakpoints.medium} {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Large */
  @media ${(props) => props.theme.breakpoints.large} {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const OtherBlogs = ({ articles, otherBlogs }) => {
  return (
    <StyledDiv>
      <StandardContainer>
        <div style={{ maxWidth: "1025px", margin: "auto" }}>
          <StyledHeading size="h1" style={{ textAlign: "center" }}>
            More articles
          </StyledHeading>
          <BlogGrid $wrappedStandard id="blogGrid">
            {otherBlogs?.map((item, index) => (
              <BlogCard
                key={`${item.title}-${index}`}
                {...item}
                {...item?.blog?.document?.data}
                url={item?.blog?.document?.url}
              />
            ))}
          </BlogGrid>
        </div>
      </StandardContainer>
    </StyledDiv>
  )
}
